module.exports = __webpack_public_path__ + "media/images/lb/940-b558df7fda8f725394ac29ab55068909.svg";